import axios from 'axios';

let form = document.querySelectorAll('.js-contact-form');

form.forEach(f => {

    const formInput = f.querySelector('.js-contact-input');
    const formHeading = f.querySelector('.js-contact-heading');
    const formError = f.querySelector('.js-contact-error');
    const formSuccess = f.querySelector('.js-contact-success');
    const formSubmit = f.querySelector('.js-contact-submit');

    const setLoading = (bool) => {
        bool ? formSubmit.classList.add('hidden') : formSubmit.classList.remove('hidden');
    };

    async function getData(formData) {
        try {
            setLoading(true);
            return await axios({
                url: '/',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: formData
            });
        } catch (err) {
            console.error(err);
        }
    }

    f.addEventListener('submit', e => {
        e.preventDefault();
        let formData = new FormData(f);

        getData(formData).then(({data}) => {
            formSubmit.classList.add('hidden');

            if (data.errors) {
                formError.classList.remove('hidden');
                formError.innerHTML = JSON.stringify(data.errors);
                return;
            }

            if (data.success) {
                formSuccess.classList.remove('hidden');
                formInput.classList.add('hidden');
                formHeading.innerHTML = 'Takk!';
                return;
            }

            formSubmit.classList.remove('hidden');
        })
            .finally(() => {
                setLoading(false);
            });
    });
});
